import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/pages/Landing";

const LINKS = [
  { label: "How It Works", id: "how-it-works" },
  { label: "Why PrimeConnect", id: "why-primeconnect" },
  { label: "The Network", id: "network" },
  { label: "Discretion", id: "discretion" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-[#FAF9F5]/85 backdrop-blur-md border-b border-[#E7E4DC]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="font-display text-2xl sm:text-[1.7rem] tracking-tight text-[#141518]"
        >
          PrimeConnect
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-sm text-[#635F57] hover:text-[#141518] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://app.primeconnect.network"
            data-testid="nav-login-btn"
            className="inline-flex whitespace-nowrap rounded-full border border-[#D8D4CA] text-[#141518] text-xs sm:text-sm font-medium px-4 sm:px-6 py-2 sm:py-2.5 hover:border-[#141518] transition-colors duration-300"
          >
            Log in
          </a>
          <button
            data-testid="nav-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#141518]"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E7E4DC] bg-[#FAF9F5] px-6 py-5 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => {
                setOpen(false);
                scrollToId(l.id);
              }}
              className="text-left text-base text-[#635F57]"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </motion.header>
  );
};
